import { createAction } from "@redux/actions/actionCreators";

const [useChangeSort, changeSort] = createAction<string>("search/changeSort");

export default useChangeSort;
export { changeSort };
